export default __webpack_public_path__ + "static/media/videoImg.f174e272.png";